<div class="password-requirements_container is-active">
  <p>Password Requirements:</p>
  <ul>
    <li>
      <mat-icon
        [ngClass]="
          passwordField?.dirty && !passwordField.errors?.isShort
            ? 'icon icon--check_circle_outline'
            : 'icon icon--block'
        "
      >
        {{ passwordField?.dirty && !passwordField.errors?.isShort ? 'check_circle_outline' : 'block' }}
      </mat-icon>
      The password must have at least 8 characters.
    </li>
    <li>
      <mat-icon
        [ngClass]="
          passwordField?.dirty && !passwordField.errors?.atLeastOneNumber
            ? 'icon icon--check_circle_outline'
            : 'icon icon--block'
        "
      >
        {{ passwordField?.dirty && !passwordField.errors?.atLeastOneNumber ? 'check_circle_outline' : 'block' }}
      </mat-icon>
      The password must include at least 1 number.
    </li>
    <li>
      <mat-icon
        [ngClass]="
          passwordField?.dirty && !passwordField.errors?.atLeastOneUpperCase
            ? 'icon icon--check_circle_outline'
            : 'icon icon--block'
        "
      >
        {{ passwordField?.dirty && !passwordField.errors?.atLeastOneUpperCase ? 'check_circle_outline' : 'block' }}
      </mat-icon>
      The password must include at least 1 upper case letter.
    </li>
    <li>
      <mat-icon
        [ngClass]="
          passwordField?.dirty && !passwordField.errors?.atLeastOneLowerCase
            ? 'icon icon--check_circle_outline'
            : 'icon icon--block'
        "
      >
        {{ passwordField?.dirty && !passwordField.errors?.atLeastOneLowerCase ? 'check_circle_outline' : 'block' }}
      </mat-icon>
      The password must include at least 1 lower case letter.
    </li>
    <li>
      <mat-icon
        [ngClass]="
          passwordField?.dirty && !passwordField.errors?.notIncludeFromEmailAddress
            ? 'icon icon--check_circle_outline'
            : 'icon icon--block'
        "
      >
        {{
          passwordField?.dirty && !passwordField.errors?.notIncludeFromEmailAddress ? 'check_circle_outline' : 'block'
        }}
      </mat-icon>
      Must not include any part of your email address.
    </li>
    <li>
      <mat-icon
        [ngClass]="
          passwordField?.dirty && !passwordField.errors?.characterInvalid
            ? 'icon icon--check_circle_outline'
            : 'icon icon--block'
        "
      >
        {{ passwordField?.dirty && !passwordField.errors?.characterInvalid ? 'check_circle_outline' : 'block' }}
      </mat-icon>
      The password only can include (#,$,%,&,&#64;,!) symbols.
    </li>
  </ul>
</div>
